<script>
import axios from '@/utils/axios';
import { Modal } from 'bootstrap';
import { useShare } from '@/composables/useShare.js';
import { byDocumentType } from '@/utils/document-setting';

export default {
inject: ['setLoading'],
data() {
  return {
    title: "Sales",
    text: "Sales",
    data: [],
    type: 'proposal',
    setting: [],
    pagination: {
      current_page: 1,
      per_page: 25,
      last_page: 1,
      total: 0,
      links: []
    },
    status: '',
    search_keyword: '',
    selected_rows: [],
  };
},

 computed: {
  serialNo(){
   return (this.pagination.current_page - 1) * this.pagination.per_page;
  },
  text1(){
   return `Proposals (${this.pagination.total})`; 
  },
  allSelected() {
   return this.data?.length && this.selected_rows.length === this.data.length;
  }
 },
 mounted() {  
  this.proposals();
  this.byType(this.type);
  const { shareContent } = useShare();
  this.shareContent = shareContent; 
 }, 

 methods: {
  
  async selectStatus(status){
   this.status = status;
   await this.proposals();
  },

  async shareProposal(row){
   const shareUrl = `/sales/proposals/view/${row.public_token}`
   const result = await this.shareContent(
    `Proposal ${row.proposal_number}`,
    `Proposal #${row.proposal_number} - ${row.party?.name || 'Client'}`, shareUrl);
  },

  async byType(type){
   this.setLoading(true);
   try{
    const response = await byDocumentType(type, this.clientAdmin?.id);
    this.setting = response.data.data;
   }catch(error){
    this.$swalToast(error.message, 'error');
   }finally{
    this.setLoading(false);
   }
  },

  handleToggleAll(event) {
   this.selected_rows = this.$toggleAll(event, this.data);
  },

  async viewPDF(id){
   try{
    const response = await axios.get(`/proposals/${id}/pdf`,{
     responseType: 'blob' 
    });

    const file = new Blob([response.data], { type: 'application/pdf' });
    const fileURL = URL.createObjectURL(file);
  
    window.open(fileURL, '_blank');
   }catch(error){
    this.$swalToast("Failed to open PDF", 'error');
    console.error(error);
   }
  },

  async proposals(page = 1){
   this.setLoading(true);
   try{
    const params = {
     page,
     status: this.status || '',
     search_keyword: this.search_keyword.trim() || ''
    };
    const query_string = new URLSearchParams(params).toString();
    const response = await axios.get(`/proposals?${query_string}`);
    this.data = response.data.data.data;
    this.pagination = {
      current_page: response.data.data.current_page,
      per_page: response.data.data.per_page,
      last_page: response.data.data.last_page,
      total: response.data.data.total,
      links: response.data.data.links
    };
   }catch(error){
    this.$swalToast(error.message, 'error');
   }finally{
    this.setLoading(false);
   }
  },

  changePage(url) {
   if (!url) return;
   const page = new URL(url).searchParams.get("page");
   this.proposals(page);
  },

  bulkAction(){
   if(this.selected_rows.length){
    this.$refs.proposalModal.bulkAction(this.selected_rows); 
    const modalEl = document.getElementById("bulk_action_proposal");
    let modal = Modal.getInstance(modalEl);
    if(!modal){ modal = new Modal(modalEl);}
    modal.show();
   }else{
    this.$swalToast("Please select at least one option.", 'error');
   }
  }, 

  clearFilter(){
   this.status = '';
   this.search_keyword = '';
   this.proposals();
  },

},
};

</script>

<template>
<layout-header></layout-header>
<layout-sidebar></layout-sidebar>

<!-- Page Wrapper -->
<div class="page-wrapper">
<div class="content">
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <breadcrumb :title="title" :text="text" :text1="text1" />
    <div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
      
      <div class="me-2 mb-2">
      <button type="button" class="btn btn-outline-secondary" @click="bulkAction();"><i class="ti ti-playstation-square me-1"></i> Bulk Actions</button> 
      </div>
      
      <div class="mb-2">
        <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#proposal_modal" class="btn btn-primary d-flex align-items-center" @click="$refs.proposalModal.add();">
          <i class="ti ti-circle-plus me-2"></i>Add Proposal
        </a>
      </div>
      
    </div>
  </div>
  <!-- /Breadcrumb -->

  <div class="card">
  <div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
  <h5>Proposals List</h5>
  <div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
    
    <div class="me-3" v-if="search_keyword !== '' || status !== '' ">
     <a href="javascript:void(0);" class="text-danger" @click="clearFilter()"><i class="ti ti-filter-x"></i></a>
    </div>  
    
    <div class="me-3">
     <select class="form-select" v-model="status" @change="proposals">
      <option value="">Status</option>
      <option value="Draft">Draft</option>
      <option value="Sent">Sent</option>
      <option value="Accepted">Accepted</option>
      <option value="Rejected">Rejected</option>
     </select>
    </div>

    <div class="me-3">
    <div class="input-icon-end position-relative">
     <input type="text" class="form-control" v-model="search_keyword" placeholder="Search...."/>
    </div>
    </div>

    <div class="me-3">
     <button type="button" class="btn btn-dark" @click="proposals()"><i class="ti ti-search"></i></button>
    </div>

    </div>
 </div>
 <div class="card-body card-table-wrapper">
  <div class="custom-datatable-filter table-responsive">
    <table class="card-table" v-if="data?.length">
      <thead>
        <tr>
          <th>
           <div class="form-check form-checkbox-success mb-2">
           <input type="checkbox" class="form-check-input" :checked="allSelected" @change="handleToggleAll">
          </div> 
          </th>
          <th>#</th>
          <th>Proposal No</th>
          <th>Subject</th>
          <th>To</th>
          <th>Total</th>
          <th>Open Till</th>
          <th>Status</th>
          <th>Assigned</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in data" :key="row.id">
          <td>
          <div class="form-check form-checkbox-success mb-2">
           <input type="checkbox" class="form-check-input" :value="row.id" v-model="selected_rows">
          </div>  
          </td>  
          <td>{{ serialNo + index + 1 }}.</td> 
          <td><a :href="`/sales/proposals/view/${row.public_token}`" target="_blank" class="text-primary">{{ row.proposal_number }}</a></td>
          <td>{{ row.subject }}</td>
          <td>{{ row.to_name }}</td>
          <td>{{ row.lead?.currency?.symbol+row.total }}</td>
          <td>{{ $formatDate(row.valid_until) }}</td>
          <td><span class="badge rounded-pill bg-outline-secondary">{{ row.status }}</span></td>
          <td><img v-if="row.user?.image" :src="row.user?.image_url" width="22" class="rounded-circle" />
          <i v-else class="ti ti-user-circle fs-18 text-muted"></i>
          {{ row.user?.name }}</td>
          <td>
            <div class="dropdown">
            <button class="btn btn-icon btn-sm rounded-circle" type="button" data-bs-toggle="dropdown" aria-expanded="false" data-bs-popper="none">
            <i class="ti ti-dots-vertical"></i>
            </button>
            <ul class="dropdown-menu dropdown-menu-end p-3">
            <li>
            <a class="dropdown-item rounded-1" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#proposal_modal" @click="$refs.proposalModal.editProposal(row.public_token)"><i class="ti ti-edit me-1"></i>Edit</a>
            </li>
            <li v-if="row.status !== 'Accepted' && row.status !== 'Rejected'">
            <a class="dropdown-item rounded-1" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#proposal_assign_modal" @click="$refs.proposalModal.assignHistory(row.id, row.proposal_number)"><i class="ti ti-user-star me-1"></i>Assign User</a>
            </li>
            <li>
            <a class="dropdown-item rounded-1" href="javascript:void(0);" @click="viewPDF(row.id)"><i class="ti ti-file-type-pdf me-1"></i>View PDF</a>
            </li>
            <li>
            <a class="dropdown-item rounded-1" href="javascript:void(0);" @click="shareProposal(row)">
             <i class="ti ti-share me-1"></i>Share Proposal
            </a>
            </li>
            <li v-if="setting?.send_on_email && row.status !== 'Accepted' ">
            <a class="dropdown-item rounded-1" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#proposal_mail_modal" @click="$refs.proposalModal.mailProposal(row)"><i class="ti ti-mail me-1"></i>Send on Email</a>
            </li>
            <li>
            <a class="dropdown-item rounded-1" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#proposal_delete_modal" @click="$refs.proposalModal.editProposal(row.public_token)"><i class="ti ti-trash me-1"></i>Delete</a>
            </li>
            </ul>
            </div> 

          </td>
        </tr>
      </tbody>
    </table>

    <div v-else class="p-3 text-center text-muted">
      No records found.
    </div>
  </div>

  <!-- Pagination -->
  <nav v-if="pagination.links && pagination.links.length > 3" class="m-3">
    <ul class="pagination">
      <li v-for="(link, index) in pagination.links" :key="index"
        :class="['page-item', { active: link.active, disabled: !link.url }]">
        <a class="page-link" href="javascript:void(0)" v-html="link.label" @click="changePage(link.url)"></a>
      </li>
    </ul>
  </nav>
</div>
</div>
</div>

<app-footer></app-footer>

</div>
<!-- /Page Wrapper -->

<proposal-modal ref="proposalModal" @updated="proposals"></proposal-modal>

</template>

<style scoped>
.table-responsive {
  overflow-y: auto;
}

</style>